import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={21.546}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22346 18733"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="Layer_x0020_1_0">
        <path
          id="_341371488"
          d="M18995 10499c-118 0-223-79-249-197-877-3482-3993-5903-7580-5903s-6702 2421-7566 5903c-39 144-170 223-314 197-144-40-236-183-197-327 930-3705 4255-6297 8077-6297 3836 0 7161 2592 8090 6297 26 144-52 287-196 327h-65z"
          className="fil0"
        />
        <path
          id="_341371728"
          d="M3351 18733H942c-143 0-261-118-261-262V3587c0-144 118-262 261-262 144 0 262 118 262 262v14622h1885V3587c0-144 105-262 262-262 144 0 262 118 262 262v14884c0 144-118 262-262 262z"
          className="fil0"
        />
        <path
          id="_341371824"
          d="M2147 4281C956 4281 0 3325 0 2134 0 956 956 0 2147 0c1178 0 2134 956 2134 2134 0 1191-956 2147-2134 2147zm0-3757c-890 0-1624 720-1624 1610s734 1623 1624 1623 1610-733 1610-1623S3037 524 2147 524z"
          className="fil0"
        />
        <path
          id="_341370768"
          d="M2147 3247c-615 0-1113-498-1113-1113 0-602 498-1100 1113-1100 602 0 1099 498 1099 1100 0 615-497 1113-1099 1113zm0-1689c-327 0-589 262-589 576 0 327 262 589 589 589 314 0 576-262 576-589 0-314-262-576-576-576z"
          className="fil0"
        />
        <path
          id="_341371248"
          d="M21403 18733h-2408c-144 0-262-118-262-262V3587c0-144 118-262 262-262 143 0 261 118 261 262v14622h1885V3587c0-144 118-262 262-262s262 118 262 262v14884c0 144-118 262-262 262z"
          className="fil0"
        />
        <path
          id="_341371104"
          d="M20199 4281c-1178 0-2147-956-2147-2147 0-1178 969-2134 2147-2134s2147 956 2147 2134c0 1191-969 2147-2147 2147zm0-3757c-890 0-1623 720-1623 1610s733 1623 1623 1623 1623-733 1623-1623-733-1610-1623-1610z"
          className="fil0"
        />
        <path
          id="_341370936"
          d="M20199 3247c-615 0-1113-498-1113-1113 0-602 498-1100 1113-1100s1099 498 1099 1100c0 615-484 1113-1099 1113zm0-1689c-327 0-589 262-589 576 0 327 262 589 589 589 314 0 576-262 576-589 0-314-262-576-576-576z"
          className="fil0"
        />
        <path
          id="_341370240"
          d="M18995 18733H3351c-157 0-262-118-262-262s105-262 262-262h15644c143 0 261 118 261 262s-118 262-261 262zm0-2658H3351c-157 0-262-117-262-261s105-262 262-262h15644c143 0 261 118 261 262s-118 261-261 261z"
          className="fil0"
        />
        <path
          id="_341370600"
          d="M5799 16075c-144 0-262-117-262-261V6192c0-157 118-262 262-262s262 105 262 262v9622c0 144-118 261-262 261z"
          className="fil0"
        />
        <path
          id="_341370312"
          d="M8483 16075c-144 0-262-117-262-261V4595c0-144 118-262 262-262s261 118 261 262v11219c0 144-117 261-261 261z"
          className="fil0"
        />
        <path
          id="_341370408"
          d="M11166 16075c-144 0-262-117-262-261V4137c0-144 118-262 262-262s262 118 262 262v11677c0 144-118 261-262 261z"
          className="fil0"
        />
        <path
          id="_341370360"
          d="M13863 16075c-144 0-262-117-262-261V4595c0-144 118-262 262-262s262 118 262 262v11219c0 144-118 261-262 261z"
          className="fil0"
        />
        <path
          id="_341369592"
          d="M16547 16075c-145 0-262-117-262-261V6192c0-157 117-262 262-262 144 0 261 105 261 262v9622c0 144-117 261-261 261z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
